<template>
    <div class="most-backed">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex justify-content-between">
                        <SectionHeader
                            title="Find the Most Backed Campaigns"
                            :align-left="true"/>
                        <div class="d-md-flex d-none slider-buttons">
                            <Icon id="mb-previous-arrow-landing" icon="landing-arrow-prev" class="swiper-button landing-slider-button-prev"/>
                            <Icon id="mb-next-arrow-landing" icon="landing-arrow-prev" class="swiper-button landing-slider-button-next"/>
                        </div>
                    </div>
                    <div>
                        <swiper class="swiper" :options="swiperOption">
                            <swiper-slide 
                                v-for="(camp, index) in data" 
                                :key="'card'+index"
                                :id="`most-backed-card-landing-${index}`">
                                    <Card :card="camp" type="slider" list="real"/>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div style="margin-top: 56px" class="d-flex justify-content-center">
                        <Button 
                            @click.native="checkAuthState" 
                            id="view-all-button"
                            data-type="landing-green">
                                View All
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SectionHeader from '../SectionHeader'
import Card from '@/components/Card'
import Icon from '@/components/Theme/Icon'
import Button from '@/components/Theme/Button'
import useMostBackedCamps from './useMostBackedCamps'
import initSwiperOptions from '../swiper.options'
import useAuthCheck from '../useAuthCheck'
export default {
    name: 'MostBacked',
    components: {
        SectionHeader,
        Card,
        Icon,
        Button
    },
    setup: function() {
        const { data } = useMostBackedCamps()
        const slidesPerView = 4
        const breakpoints = true
        const { swiperOption } = initSwiperOptions(slidesPerView, breakpoints)
        const { checkAuthState } = useAuthCheck('Landing View All')
        return {
            data,
            swiperOption,
            checkAuthState
        }
    }
}
</script>

<style scoped lang="scss">
.most-backed {
    min-height: 100vh;
    display: flex;
    align-items: center;
    padding-top: 48px;
    padding-bottom: 48px;
    background: #F8F8FF;

    div.slider-buttons {
        display: flex;
        justify-content: center;
        align-items: flex-start;

        img {
            cursor: pointer;
            filter: grayscale(1);
            transition: all 0.1s ease;
            &:last-child {
                transform: rotate(180deg);
                margin-left: 24px;
            }
            &:focus {
                outline: none;
                border: none;
            }
            &:hover {
                filter: none;
            }
        }
    }
}
@media (max-width: 767px) {
    div.most-backed {
        padding-top: 48px !important;
        padding-bottom: 56px;
    }
}
</style>